export default class UpdateSite {
  constructor() {
    const me = this;
    if ($('.deployments-website-update-aliases-add')) {
      $('.deployments-website-update-aliases-add').each(function(i, aliasAdd) {
        let $aliasAdd = $(aliasAdd);
        let $aliasList = $($aliasAdd.data('target'));
        let $aliasName = $aliasAdd.parents('.form-group').find(':input');

        $aliasList.data('index', $aliasList.find(':input').length);

        $aliasAdd.on('click', function() {
          me.addAlias($aliasList, $aliasName.val());
          $aliasName.val('');
          me.resetLabelNumbers.bind(this, $aliasList);
        });

        $aliasList.on('click', '.deployments-website-update-aliases-remove', function(e) {
          me.removeAlias($aliasList, e.target);
          me.resetLabelNumbers.bind(this, $aliasList);
        });

        me.resetLabelNumbers.bind(this, $aliasList);
      })
    }

    this.ALIAS_TEMPLATE = '<div class="form-group">' +
    '<label for="__id__" class="required">Alias</label>' +
    '<div class="input-group">' +
    '__widget__' +
    '<div class="input-group-append align-items-end">' +
    '<button type="button" class="btn btn-color1 text-white deployments-website-update-aliases-remove">' +
    'Remove <i aria-hidden="true" class="fas fa-minus ps-2"></i>' +
    '</button>' +
    '</div>' +
    '</div>' +
    '</div>';
  }

  addAlias($aliasList, defaultValue) {
    let widgetId = $aliasList.data('name-id');
    let widgetPrototype = $aliasList.data('name-prototype');
    let index = $aliasList.data('index');

    let newHtml = this.ALIAS_TEMPLATE
      .replace(/__id__/g, widgetId)
      .replace(/__widget__/g, widgetPrototype)
      .replace(/__name__/g, index);

    let $newRow = $(newHtml);

    if (defaultValue) {
      $newRow.find(':input').val(defaultValue);
    }

    $aliasList.append($newRow);

    $aliasList.data('index', index + 1);
  }

  removeAlias($aliasList, clickedButton) {
    $(clickedButton).parents('.form-group').remove();
  }

  resetLabelNumbers($aliasList) {
    $aliasList.find('.form-group').each(function(index, row) {
      this.resetLabelNumber($(row), index + 1);
    });
  }

  resetLabelNumber($aliasRow, number) {
    let label = $aliasRow.find('label').get(0);
    label.innerText = label.innerText.replace(/\s*\d*$/, '') + ' ' + number;
  }
}
